/**
 * KAN-834: как добавить приложение на главный экран.
 * Android: кнопка системной установки; iPhone: два шага с картинками кнопок
 * "Поделиться" и "На экран Домой". KAN-845: показывается в шаге 1 экрана
 * "Начало работы" (данные из useInstallPrompt передаёт хук шагов).
 * Android во встроенном браузере (Telegram): открыть ссылку в Chrome.
 */
import { Download, PlusSquare, Share } from 'lucide-react';
import type { InstallPrompt } from '@/hooks/useInstallPrompt';

export const INSTALL_INAPP_TEXT =
  'Откройте ссылку в Chrome: меню ⋮, затем Открыть в Chrome, и там Установить приложение.';

export function InstallInstructions({ kind, install }: InstallPrompt): JSX.Element | null {
  if (kind === 'installed') return null;
  if (kind === 'prompt') {
    return (
      <button
        type="button"
        onClick={() => void install()}
        className="inline-flex min-h-[48px] w-full items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 text-base font-medium text-white active:bg-blue-700"
      >
        <Download className="h-5 w-5" aria-hidden="true" />
        Установить приложение
      </button>
    );
  }
  if (kind === 'ios') {
    return (
      <ol className="space-y-2 text-sm text-gray-800" data-testid="install-ios">
        <li className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-gray-300 bg-white">
            <Share className="h-5 w-5 text-blue-600" aria-hidden="true" />
          </span>
          <span>1. Нажмите "Поделиться" внизу экрана</span>
        </li>
        <li className="flex items-center gap-3">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg border border-gray-300 bg-white">
            <PlusSquare className="h-5 w-5 text-gray-800" aria-hidden="true" />
          </span>
          <span>2. Выберите "На экран Домой"</span>
        </li>
      </ol>
    );
  }
  if (kind === 'inapp') {
    return (
      <p className="text-sm text-gray-700" data-testid="install-inapp">
        {INSTALL_INAPP_TEXT}
      </p>
    );
  }
  return (
    <p className="text-sm text-gray-700">
      Откройте меню браузера и выберите "Установить приложение" или "Добавить на главный экран".
    </p>
  );
}
